import axios from 'axios';

export default axios.create({
  headers: {
    accept: 'application/json',
  },
  withCredentials: true,
});
